import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScrEnvironment } from "src/environments/environment";
import { octetStreamDownload, WithCredNoCache } from "./authentication.service";
import { ScrBaseResponse, ScrBaseService } from "./base.service";
import { ScrServiceManager } from "./servicemanager.service";

export class RegistryReportData {
    public approved?: RegistryReportDataInfo;
    public carrier?: RegistryReportDataInfo;
    public carrierWeekly?: RegistryReportDataInfo;
    public registry?: RegistryReportDataInfo;
}

export class RegistryReportDataInfo {
    public lastRunDate!: string;
    public downloadUrl!: string;
}

export class GetRegistryReportResponse extends ScrBaseResponse {
    data!: RegistryReportData;
}


@Injectable({
    providedIn: 'root'
})
export class CarrierReportService extends ScrBaseService {

    constructor(
        serviceManager: ScrServiceManager,
        private environment: ScrEnvironment,
        private http: HttpClient) {
        super(serviceManager);

    }

    getReports(): Observable<GetRegistryReportResponse> {
        const url = `${this.environment.base}/secure/codemanagement/registryreports`;
        return this.http.get<GetRegistryReportResponse>(url, WithCredNoCache);
    }

    getAgedReports(type: string): Observable<HttpResponse<Blob>> {
        const url = `${this.environment.base}/secure/codemanagement/downloadagedshortcodes?type=${type}`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }

    getTransferReportDateRange(type: string, start?: string, end?: string): Observable<HttpResponse<Blob>> {
        let url;
        if (start && end) {
            url = `${this.environment.base}/secure/codemanagement/downloadtransfers?type=${type}&startDate=${start}&endDate=${end}`;
        } else {
            url = `${this.environment.base}/secure/codemanagement/downloadtransfers?type=${type}`;
        }
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }
}